export const AVAILABILITY_HEADER_VARIABLES = ['{appointmentType}'];
